import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_COMS_EVENT_LIST, GET_COMS_EVENT_LIST_SUCCESS, GET_COMS_EVENT_LIST_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getComsEventList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefitPacks`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        'X-Thriwe-Comms-Key': 'STAG_COMMS_KEY',
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: GET_COMS_EVENT_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMS_EVENT_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMS_EVENT_LIST_ERROR, payload: error });
  }
}

export function* watchComsEventList() {
  yield takeEvery(GET_COMS_EVENT_LIST, getComsEventList);
}

function* getComsEventListSaga() {
  yield all([fork(watchComsEventList)]);
}

export default getComsEventListSaga;
